export default __webpack_public_path__ + "static/media/Path3505.52840da1.svg";